import { RegisteredComponent } from "@builder.io/sdk-react";
import { THEME_FIELD } from "../commonFields";

export const comparisonChartBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Comparison Chart",
  noWrap: true,
  image:
    "https://icons.veryicon.com/png/o/system/graduate-system/information-comparison.png",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
    builderLinkComponent: true,
  },
  canHaveChildren: true,
  childRequirements: {
    component: "Table Row",
    message: "Comparison Chart can only have Table Row components as children!",
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Table Row",
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Table Row",
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Table Row",
      },
    },
  ],
  inputs: [
    {
      name: "ariaLabel",
      type: "string",
      localized: true,
      required: true,
      helperText:
        "Caption for screen readers describing the comparison chart table.",
    },
    {
      name: "highlightColumnIndex",
      type: "number",
      helperText:
        "Index of the column to highlight. (can be highlighted from 1 = second column)",
      localized: false,
    },
    THEME_FIELD,
  ],
  defaultStyles: {
    width: "100%",
  },
};
